import React, { useEffect, useState } from 'react'
import ProjectsTabSA from './ProjectsTabSA';
import TimeSheetSA from './TimeSheetSA';
import DSRAbsentSA from './DSRAbsentSA';
import { useSelector } from 'react-redux';
import { selectUser } from 'src/stores/userSlice';
import LeaveTabSA from './LeaveTabSA';
import ManagerLeaveWfhOverview from '../components/ManagerLeaveWfhOverview';

function AdminPage() {
    const [currentActiveTab, setCurrentActiveTab] = useState('1');
    const user = useSelector(selectUser);
    const [empCode, setEmpCode] = useState('');

    const rawKaitongo = process.env.REACT_APP_KAITONGO_MANAGER || '';
    const Kaitongo = rawKaitongo.split(',');

    const toggle = tab => {
        if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    }

    useEffect(() => {
        if (user !== null) {
            if (Kaitongo.includes(user.emp_code)) {
                setEmpCode(user.emp_code);
                setCurrentActiveTab('2')
            } else {
                setEmpCode('');
            }
        }
    }, [user])

    const TabButton = ({ id, label }) => (
        <button
            type="button"
            onClick={() =>{ 
                toggle(id);
                  console.log('foewaofff')
            }}
            className={`relative px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
                currentActiveTab === id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
        >
            {label}
        </button>
    );

    return (
        <div className="bg-transparent w-full h-full flex flex-col overflow-y-auto overflow-x-hidden">
            <div className="max-w-[1700px] mx-auto px-2 sm:px-4 py-2 sm:py-2 flex-1 w-full flex flex-col mb-2">
                {!empCode && (
                    <div className="sticky top-0 z-10 bg-[#f6f6f6] pb-3 pt-2 -mt-2 -mx-2 sm:-mx-4 px-2 sm:px-4">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                            <div className="flex overflow-x-auto scrollbar-hide">
                                <TabButton id="1" label="Projects" />
                                <TabButton id="2" label="Time Sheet" />
                                <TabButton id="4" label="DSR Compliance" /> 
                                <TabButton id="5" label="Time-Off & WFH" />
                            </div>
                        </div>
                    </div>
                )}

                <div className="flex-1">
                    {currentActiveTab === '1' && <ProjectsTabSA />}
                    {currentActiveTab === '2' && <TimeSheetSA />}
                    {currentActiveTab === '4' && <DSRAbsentSA />}
                    {currentActiveTab === '5' && <ManagerLeaveWfhOverview />}
                </div>
            </div>
        </div>
    )
}

export default AdminPage;